import { render, staticRenderFns } from "./ConfirmationDialog.vue?vue&type=template&id=0cb71646&scoped=true"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationDialog.vue?vue&type=style&index=0&id=0cb71646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb71646",
  null
  
)

export default component.exports